/* Cloud Hidden — FAQ pages behaviour (Shopify Atelier)
   Accordion · live search · contents-rail scroll-spy · filter chips.
   Tweaks panel stripped — settings are driven by section schema instead.
   Scoped to a .ch-faq[data-faq-root] container element.
*/
(function () {
  'use strict';

  function initFaq(root) {
    var layout  = root.dataset.faqLayout  || 'accordion';
    var nav     = root.dataset.faqNav     || 'rail';
    var density = root.dataset.faqDensity || 'spacious';
    var search  = root.dataset.faqSearch  !== 'false';
    var accent  = root.dataset.faqAccent  || '#8c3a1a';

    // Apply config
    root.style.setProperty('--faq-accent', accent);
    if (layout  === 'open')    root.querySelector('.faq-main').classList.add('layout-open');
    if (density === 'compact') root.classList.add('is-compact');
    if (nav     === 'chips')   root.querySelector('.faq-shell').classList.add('nav-chips');
    var searchEl = root.querySelector('.faq-search');
    if (searchEl && !search)   searchEl.classList.add('is-hidden');

    numberQuestions(root);
    buildNav(root);
    initAccordion(root, layout);
    initSearch(root, layout);
    initScrollSpy(root);
  }

  function setOpen(q, open) {
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function numberQuestions(root) {
    root.querySelectorAll('.faq-cat').forEach(function (cat) {
      cat.querySelectorAll('.faq-item').forEach(function (item, i) {
        var q = item.querySelector('.faq-q');
        if (!q || q.querySelector('.faq-q__n')) return;
        var n = document.createElement('span');
        n.className = 'faq-q__n';
        n.textContent = String(i + 1).padStart(2, '0');
        q.insertBefore(n, q.firstChild);
      });
    });
  }

  function buildNav(root) {
    var cats     = Array.from(root.querySelectorAll('.faq-cat'));
    var railList = root.querySelector('.faq-rail__list');
    var chips    = root.querySelector('.faq-chips');

    if (railList) {
      cats.forEach(function (cat) {
        var a = document.createElement('a');
        a.className = 'faq-rail__link';
        a.href = '#' + cat.id;
        a.textContent = cat.dataset.label || cat.querySelector('.faq-cat__title').textContent;
        a.dataset.target = cat.id;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var top = cat.getBoundingClientRect().top + window.scrollY - 88;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        railList.appendChild(a);
      });
    }

    if (chips) {
      var all = document.createElement('button');
      all.className = 'faq-chip is-active';
      all.textContent = 'All';
      all.dataset.target = '__all';
      chips.appendChild(all);
      cats.forEach(function (cat) {
        var b = document.createElement('button');
        b.className = 'faq-chip';
        b.textContent = cat.dataset.label || cat.querySelector('.faq-cat__title').textContent;
        b.dataset.target = cat.id;
        chips.appendChild(b);
      });
      chips.addEventListener('click', function (e) {
        var btn = e.target.closest('.faq-chip');
        if (!btn) return;
        clearSearch(root);
        chips.querySelectorAll('.faq-chip').forEach(function (c) {
          c.classList.toggle('is-active', c === btn);
        });
        var target = btn.dataset.target;
        cats.forEach(function (cat) {
          cat.classList.toggle('is-filtered-out', target !== '__all' && cat.id !== target);
        });
        showEmpty(root, false);
      });
    }
  }

  function initScrollSpy(root) {
    var cats  = Array.from(root.querySelectorAll('.faq-cat'));
    var links = Array.from(root.querySelectorAll('.faq-rail__link'));
    if (!cats.length || !links.length) return;
    var byId = {};
    links.forEach(function (l) { byId[l.dataset.target] = l; });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          var active = byId[entry.target.id];
          if (active) active.classList.add('is-active');
        }
      });
    }, { rootMargin: '-88px 0px -65% 0px', threshold: 0 });
    cats.forEach(function (c) { obs.observe(c); });
  }

  function initAccordion(root, layout) {
    root.querySelectorAll('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        if (layout === 'open') return;
        setOpen(q, q.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  function normalize(s) {
    return (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function showEmpty(root, show, query) {
    var empty = root.querySelector('.faq-empty');
    if (!empty) return;
    empty.style.display = show ? 'block' : 'none';
    if (show && query) {
      var q = empty.querySelector('[data-q]');
      if (q) q.textContent = query;
    }
  }

  function clearSearch(root) {
    var input = root.querySelector('.faq-search input');
    if (!input) return;
    input.value = '';
    runSearch(root, '', 'accordion');
  }

  function runSearch(root, q, layout) {
    var query = normalize(q);
    var cats  = Array.from(root.querySelectorAll('.faq-cat'));
    var total = 0;
    var chips = root.querySelector('.faq-chips');
    if (chips) {
      chips.querySelectorAll('.faq-chip').forEach(function (c, i) {
        c.classList.toggle('is-active', i === 0);
      });
    }
    cats.forEach(function (cat) {
      var matchesInCat = 0;
      cat.querySelectorAll('.faq-item').forEach(function (item) {
        var hay = normalize(item.textContent);
        var hit = !query || hay.includes(query);
        item.classList.toggle('is-filtered-out', !hit);
        if (hit) { matchesInCat++; total++; }
        if (layout !== 'open') {
          var btn = item.querySelector('.faq-q');
          if (btn) setOpen(btn, !!(query && hit));
        }
      });
      cat.classList.toggle('is-filtered-out', matchesInCat === 0);
    });
    var clearBtn = root.querySelector('.faq-search__clear');
    if (clearBtn) clearBtn.classList.toggle('is-shown', !!query);
    showEmpty(root, !!(query && total === 0), query);
  }

  function initSearch(root, layout) {
    var wrap = root.querySelector('.faq-search');
    if (!wrap) return;
    var input    = wrap.querySelector('input');
    var clearBtn = wrap.querySelector('.faq-search__clear');
    input.addEventListener('input', function () { runSearch(root, input.value, layout); });
    clearBtn.addEventListener('click', function () {
      input.value = '';
      runSearch(root, '', layout);
      input.focus();
    });
  }

  // Boot — guard against Shopify sections loading after DOMContentLoaded has fired
  function bootFaq() {
    document.querySelectorAll('.ch-faq[data-faq-root]').forEach(initFaq);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFaq);
  } else {
    bootFaq();
  }
})();
